<template>
  <div v-if="statisticsOrder">
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />

      </b-col>
    </b-row>

    <b-row>
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمار 7 روز گذشته، تراکنش ها
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong>مجموع تعداد تراکنش (success+fail+pending) :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_last_7_days_count}}

            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد تراکنش های موفق (success)  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_last_7_days_success_count}}

            </b-badge>
            <span>
              تعداد
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد تراکنش های ناموفق (fail) :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="danger">
              {{statisticsOrder.total_transactions_last_7_days_fail_count}}

            </b-badge>
            <span>
              تعداد
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد تراکنش های در انتظار پرداخت (pending) :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{
                statisticsOrder.total_transactions_last_7_days_count
            -
                (statisticsOrder.total_transactions_last_7_days_fail_count
                    +
                    statisticsOrder.total_transactions_last_7_days_success_count)}}

            </b-badge>
            <span>
              تعداد
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل تراکنش های درخواستی (اگر پرداخت میشد :)  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="danger">
              {{
                numberFormat(statisticsOrder.total_paid_last_7_days)
           }}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل تراکنش های موفق و پرداخت شده  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{
                numberFormat(statisticsOrder.total_paid_last_7_days_success)
              }}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل تراکنش های ناموفق (کنسل یا رفته درگاه پرداخت انصراف داده (fail) )  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="danger">
              {{
                numberFormat(statisticsOrder.total_paid_last_7_days_fail)
              }}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل تراکنش های در انتظار پرداخت (قبل از درگاه (pending) )  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{
              numberFormat(statisticsOrder.total_paid_last_7_days
                  -
                  (statisticsOrder.total_paid_last_7_days_success
                      +
                      statisticsOrder.total_paid_last_7_days_fail))}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
      </div>
    </b-row>

    <b-row class="my-2">
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمار 30 روز گذشته، تراکنش ها
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong>مجموع تعداد تراکنش (success+fail+pending) :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_last_month_count}}

            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد تراکنش های موفق (success)  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_last_month_success_count}}

            </b-badge>
            <span>
              تعداد
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد تراکنش های ناموفق (fail) :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="danger">
              {{statisticsOrder.total_transactions_last_month_fail_count}}

            </b-badge>
            <span>
              تعداد
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد تراکنش های در انتظار پرداخت (pending) :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{
                statisticsOrder.total_transactions_last_month_count
                -
                (statisticsOrder.total_transactions_last_month_fail_count
                    +
                    statisticsOrder.total_transactions_last_month_success_count)}}

            </b-badge>
            <span>
              تعداد
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل تراکنش های درخواستی (اگر پرداخت میشد :)  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="danger">
              {{
                numberFormat(statisticsOrder.total_paid_last_month_days)
              }}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل تراکنش های موفق و پرداخت شده  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{
                numberFormat(statisticsOrder.total_paid_last_month_days_success)
              }}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل تراکنش های ناموفق (کنسل یا رفته درگاه پرداخت انصراف داده (fail) )  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="danger">
              {{
                numberFormat(statisticsOrder.total_paid_last_month_days_fail)
              }}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع کل تراکنش های در انتظار پرداخت (قبل از درگاه (pending) )  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{
                numberFormat(statisticsOrder.total_paid_last_month_days
                    -
                    (statisticsOrder.total_paid_last_month_days_success
                        +
                        statisticsOrder.total_paid_last_month_days_fail))}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
      </div>
    </b-row>

    <b-row class="my-2">
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
           آمارهای نسبی پرداختی های مهمان 7 روز گذشته
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش زیر 2 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_under_2_million_last_7_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش بین 2 میلیون تا 5 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_2_and_5_million_last_7_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش بین 5 میلیون تا 7 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_5_and_7_million_last_7_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>

        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بالای 10 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_over_10_million_last_7_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>

        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بین 10  الی 15 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_10_and_15_million_last_7_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بالای 20 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_over_20_million_last_7_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
      </div>
    </b-row>

    <b-row class="my-2">
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمارهای نسبی پرداختی های مهمان 30 روز گذشته
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش زیر 2 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_under_2_million_last_30_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش بین 2 میلیون تا 5 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_2_and_5_million_last_30_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش بین 5 میلیون تا 7 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_5_and_7_million_last_30_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>

        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بالای 10 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_over_10_million_last_30_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>

        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بین 10  الی 15 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_10_and_15_million_last_30_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بالای 20 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_over_20_million_last_30_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
      </div>
    </b-row>
    <b-row class="my-2">
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمارهای نسبی پرداختی های مهمان 90 روز گذشته
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش زیر 2 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_under_2_million_last_90_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش بین 2 میلیون تا 5 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_2_and_5_million_last_90_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش بین 5 میلیون تا 7 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_5_and_7_million_last_90_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>

        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بالای 10 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_over_10_million_last_90_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>

        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بین 10  الی 15 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_between_10_and_15_million_last_90_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
        <div class="d-flex">
          <div class="pr-1">
            <strong> تعداد تراکنش  بالای 20 میلیون تومان :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.total_transactions_over_20_million_last_90_days}}

            </b-badge>
            <span>
              عدد
            </span>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BBadge,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";

export default {
  components: {
    BBadge,
    StatisticCardVertical,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      statisticsOrder: [],
      residences: null,
      cars: null,
      tours: null,
      experiences: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      countryInput: {
        name: "",
        slug:"",
        status:"active"

      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.getStatisticsOrder();
  },

  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    async getStatisticsOrder() {
      this.cancelToken = this.$http.CancelToken.source();
      const requestData = {
        method: "get",
        url: "/admin/statistics/reports_transactions",

      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.statisticsOrder = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },




  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
